<template>
    <div>
        <CategoryAsideBlock :title="filterTitle" class="filter-list">
            <div
                v-for="filter in filterList"
                :key="filter.key"
                class="filter-list__block"
            >
                <div :is="filter.component" v-bind="filter" />
            </div>

            <!--{{ categoryPath }}-->

            <!--{{ categoryTree }}-->
        </CategoryAsideBlock>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { CategoryAsideBlock } from '../Category'
import FilterListTypeBase from './FilterListType/FilterListTypeBase.vue'
import FilterListTypeCheckbox from './FilterListType/FilterListTypeCheckbox.vue'
import FilterListTypeToggle from './FilterListType/FilterListTypeToggle.vue'
import FilterListTypeRange from './FilterListType/FilterListTypeRange.vue'

// we have to map API values for example "checkbox"
// because we can't register components with native html name
const filterTypes = {
    checkbox: 'FilterListTypeCheckbox',
    multiselect: 'FilterListTypeCheckbox',
    select: 'FilterListTypeCheckbox',
    toggle: 'FilterListTypeToggle',
    range: 'FilterListTypeRange'
}

export default {
    components: {
        CategoryAsideBlock,
        FilterListTypeBase,
        FilterListTypeCheckbox,
        FilterListTypeToggle,
        FilterListTypeRange
    },
    inject: ['mediaQueries'],
    props: {
        filters: {
            type: Object,
            default: () => ({})
        },
        categoryTree: {
            type: Object,
            default: () => ({})
        },
        categoryPath: {
            type: String,
            default: () => ''
        },
        titleDisplay: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters(['getFilterByKey', 'i18n']),
        filtersSortedByKey() {
            return Object.keys(this.filters).sort(
                (a, b) =>
                    this.filters[a].filter_order - this.filters[b].filter_order
            )
        },
        filterList() {
            const filterList = this.filtersSortedByKey.map((key) => ({
                key,
                name: key,
                component: this.getFilterType(this.filters[key]),
                filter: this.getFilterByKey(key, this.mediaQueries.mobile)
            }))
            this.setActiveFilterList(filterList)
            return filterList
        },
        filterTitle() {
            return this.titleDisplay ? 'Filtruj produkty' : ''
        }
    },
    methods: {
        getFilterType(filter) {
            const { filter_renderer_type } = filter
            if (!this.$options.components[filterTypes[filter_renderer_type]]) {
                // return fallback filter type
                return ''
            }
            return filterTypes[filter_renderer_type]
        },
        setActiveFilterList(filterList) {
            const activeFiltersCount = filterList.reduce((acc, curr) => {
                let filtersCount = 0
                curr.filter?.values?.length > 0
                    ? curr.filter.values.forEach((filter) => {
                          if (filter.active)
                              filtersCount = filtersCount + filter.product_count
                      })
                    : null

                return acc + filtersCount
            }, 0)
            return this.$emit('activeFiltersCount', activeFiltersCount)
        }
    }
}
</script>
<style scoped lang="scss">
.filter-list {
    &__block:not(:empty) {
        margin-bottom: 2rem;
        border-bottom: 1px solid $sherpa-blue-light;

        .h3 {
            @media #{$media-to-sm} {
                font-weight: 600;
                font-size: 16px;
                line-height: 22px;
            }
        }
    }
}
</style>
